<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <form @submit.prevent="save" v-if="entity">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="col-form-label" for="descrizione">Codice</label>
                  <input
                    type="text"
                    id="descrizione"
                    name="descrizione"
                    placeholder="Codice"
                    v-model="entity.code"
                    class="form-control"
                  />
                  <!--<span >{{ errors[0] }}</span>-->
                </div>
              </div>
          
              <div class="col-12">
                <label class="col-form-label" for="descrizione">Banca</label>
                <v-select
                  placeholder="Seleziona banca di riferimento"
                  label="name"
                  :multiple="false"
                  index="companyId"
                  v-model="entity.companyId"
                  :options="cuser.companies"
                ></v-select>
              </div>
              <div class="col-12">
                <label class="col-form-label" for="descrizione"
                  >Contenuto</label
                >
                <editor
                  :api-key="tinyKey"
                  tinymceScriptSrc="/tinymce_7.1.0/tinymce/js/tinymce/tinymce.min.js"
                  :init="{
                    height: 500,
                    relative_urls : false,
                    remove_script_host : false,
                    menubar: false,
                    forced_root_block : false,
                    plugins: [
                    'advlist','autolink','lists','link','image','charmap','print','preview','anchor',
      'searchreplace','visualblocks','code','fullscreen',
'insertdatetime','media','table','paste','code','help','wordcount'
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic backcolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent indent | removeformat | code',
                  }"
                  v-model="entity.content"
                ></editor>
              </div>
            </div>

            <div class="form-group mt-3">
              <button
                type="button"
                class="btn btn-xs btn-primary-rgba mr-2"
                v-on:click="save"
              >
                Salva
                <font-awesome-icon :icon="['far', 'save']"></font-awesome-icon>
              </button>
              <button
                type="button"
                class="btn btn-xs btn-danger-rgba mr-2"
                v-on:click="cancel"
              >
                Annulla
                <font-awesome-icon
                  :icon="['far', 'times-circle']"
                ></font-awesome-icon>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueselect from "vue-select";
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";

export default {
  data() {
    return {
      entity: null,
    };
  },
  computed: {
    cuser() {
      return this.$store.state.user;
    },
    tinyKey: function () {
      return window.SETTINGS.TinyApiKey;
    },
  },
  components: {
    Editor
  },
  name: "templateSave",
  beforeMount() {
    this.loaddata();
  },
  methods: {
    loaddata() {
      var me = this;

      axios.get("signature/" + (me.$route.params.id || "")).then((response) => {
        me.entity = response.data;
        if (me.entity.name && me.entity.name != "") {
          me.$store.state.breadCrump.title = me.entity.name;
        }
      });
    },
    cancel() {
      this.$router.push({
        name: "route-signature-list",

        replace: true,
      });
    },

    updateFromPicker(color) {
      this.entity.backgroundColor = color.hex;
    },
    save() {
      let me = this;

      axios.post("signature", this.entity).then((response) => {
        if (me.$route.params.id != response.data.signatureId) {
          me.$router.push({
            name: "route-signature-edit",
            params: { id: response.data.signatureId },
          });
        }

        me.$swal({
          title: "Salvataggio avvenuto correttamente",
          text: "",
          type: "success",
          showCancelButton: false,
          toast: true,
          timer: 2000,
          showConfirmButton: false,
          position: "bottom-top",
        });
      });
    },
  },
};
</script>
